import { Aside } from "../../styles/mame-styled/core/HtmlTag";
import type { ReactElement } from "react";

export default function Sidebar(): ReactElement {
  return <>
    <Aside>
      
    </Aside>
  </>;
}
